import T from 'utils/T';
import ex from 'utils/ex';
import PatientInfo from './PatientInfo';
import Period from './period';
import DrGuideButton from './DrGuideButton';

import HBox from 'components/common/HBox';
import LogoutButton from './LogoutButton';
import useLogined from 'hooks/app/useLogined';

import './Header.css';

export default function Header(props) {
  const {
    renderAll,
    front,
    children,
    ...rest
  } = props || {};

  const logined = useLogined();
  if (!logined) return null;

  return (
    <div {...ex('Header', rest)}>
      <div>
        <PatientInfo {...rest} />
      </div>
      <HBox>
        <Period {...rest} >
          {children}
        </Period>
        <svg width={1} height={12} viewBox="0 0 1 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="0.5" y1="2.18557e-08" x2="0.499999" y2={12} stroke="#D8D8D8" strokeDasharray="1 1" />
        </svg>
        <LogoutButton />
      </HBox>
    </div>
  );
}
